import tw from 'twin.macro';

import { TagRowType } from '@insights_module/types/Megaphone';
import { CheckMarkIcon } from '@icons/CheckMarkIcon';
import { ClipboardIcon } from '@icons/ClipboardIcon';

const Code = tw.span`max-w-[165px] text-accent-1 uppercase text-[12px] font-semibold whitespace-nowrap truncate`;
const Flex = tw.div`flex items-center w-full overflow-hidden text-ellipsis`;
const ActionButton = tw.button`border border-solid border-gray-3 rounded p-1 bg-gray-3`;

export const CodeCell = (
  item: keyof TagRowType,
  copiedTag: string | null,
  onClick: (item: string | null) => void
): JSX.Element => {
  const handleCopyToClipboard = () => {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(item);

      onClick(item);
      setTimeout(() => onClick(null), 1000);
    }
  };

  return (
    <Flex>
      <Code>{item}</Code>
      <ActionButton tw='ml-2' onClick={handleCopyToClipboard}>
        {copiedTag === item ? (
          <CheckMarkIcon tw='stroke-accent-1 w-3 h-3' />
        ) : (
          <ClipboardIcon tw='stroke-accent-1 w-3 h-3' />
        )}
      </ActionButton>
    </Flex>
  );
};
